export interface ReferralAttribution {
  code: string;
  actorId: string;
  originActorId?: string;
  ownerUserId?: string;
  generation?: number;
  replacedCodes?: string[];
}
